import {
  ACTION_COLUMN_KEY,
  createActionColumn,
} from '../dataTableNewRenderers';
import { ColumnEntry } from './types';

const EMPTY_ACTION_TEMPLATE = () => null;

/**
 * Catalog entry for the per-row action menu. Structural: always visible,
 * excluded from customization. Pages keep pinning it via
 * `pinnedRightColumns={[ACTION_COLUMN_KEY]}`.
 */
export function actionCatalogColumn<
  TData extends object,
>(): ColumnEntry<TData> {
  return {
    id: ACTION_COLUMN_KEY,
    label: 'Actions',
    customizable: false,
    build: ({ actionBodyTemplate }) =>
      createActionColumn<TData>(actionBodyTemplate ?? EMPTY_ACTION_TEMPLATE),
  };
}
